<div class="container-fluid p-h-0 p-v-20 h-100 bg" style="background-image: url('assets/images/others/login-bg.png')">
  <div class="d-flex flex-column justify-content-between h-100">
    <div class=" d-md-block"></div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-7 col-lg-5 m-h-auto">
          <nz-card class="m-b-100 shadow-lg">
            <div class="d-flex align-items-center justify-content-between m-b-30">
              <img style="margin:auto" class="img-fluid" alt="" src="assets/images/logo/logohtnm.jpg">
            </div>
            <div class="display-block text-center text-dark">
              <img class="img-fluid w-90" src="assets/images/others/error-2.png" alt="">
              <p class="font-size-17 my-1">Đăng xuất thành công.</p>
              <p class="font-size-15 font-weight-light">Hẹn gặp lại bạn lần sau!</p>
              <a style="padding: 1em 2.5em; height: unset" nz-button class="w-100" [nzType]="'primary'" href="/auth/login">QUAY LẠI TRANG ĐĂNG NHẬP</a>
            </div>

          </nz-card>
        </div>
      </div>
    </div>
    <div class=" d-md-flex p-h-40 justify-content-between">
      <ul class="list-inline">
        <li class="list-inline-item">
          <a class="text-dark text-link" href="">Legal</a>
        </li>
        <li class="list-inline-item">
          <a class="text-dark text-link" href="">Privacy</a>
        </li>
      </ul>
    </div>
  </div>
</div>
